/**
* @ngdoc component
* @name cms.component:cmsList
* @description
* Component description
*/
(function() {
    'use strict';

    var cmsList = {
        bindings: {
            data:'<',
            state:'<'
        },
        controllerAs: '$ctrl',
        controller:   cmsListCtrl,
        templateUrl: 'cms-list.component.html'
    };
    angular.module('itxApp.help').component('cmsList',cmsList);

    
    cmsListCtrl.$inject = ['$state','$stateParams'];

    function cmsListCtrl ($state,$stateParams) {
        var _this = this;

        _this.$onInit = function () {
            // Links in the list
            _this.links = _this.data.entityMap;

            _this.list = _.forEach(_this.data.blocks, _this.addLinks);
            _this.list = _this.list.filter(function(item) {
                return item.text !== '';
            });

            if(_this.list.length === 1 &&  _this.list[0].link){
                /*$state.go('content',
                    {  submenu: $stateParams.submenu,
                        contentDesc: _this.list[0].link},
                    {location:'replace'});*/
            }
           
        };

        _this.addLinks = function(item){
            if( item.entityRanges && item.entityRanges.length>0){
                var linkKey = item.entityRanges[0].key;
                item.link=_this.links[linkKey].data.src;
            }
            return item;
        };

        _this.goToState = function(state){
            $state.go(_this.state.stateName,
                        {  submenu: $stateParams.submenu,
                            contentDesc: state});
        };

        this.deleteItemByLink = function(link) {
            _this.list = _this.list.filter(function(item) {
                return item.link !== link
            }) 
        }

     
        

    }

    

})();